import React from 'react';

const MongoDB_limit = () => {
  return (
    <div>
      <h1>MongoDB_limit Component</h1>
      <p>This is the MongoDB_limit page.</p>
    </div>
  );
};

export default MongoDB_limit;
